import { Controller } from "@hotwired/stimulus"

// Show a directional cue only while content remains beyond that edge.
export default class extends Controller {
  static targets = ["viewport", "content", "up", "down"]

  connect() {
    this.observer = new ResizeObserver(() => this.update())
    this.observer.observe(this.viewportTarget)
    this.observer.observe(this.contentTarget)
    this.update()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  contentTargetConnected(content) {
    if (!this.observer) return

    this.observer.observe(content)
    this.update()
  }

  contentTargetDisconnected(content) {
    this.observer?.unobserve(content)
  }

  update() {
    if (!this.hasViewportTarget || !this.hasUpTarget || !this.hasDownTarget) return

    const {scrollTop, scrollHeight, clientHeight} = this.viewportTarget
    const above = scrollTop > 1
    const below = scrollHeight - clientHeight - scrollTop > 1
    this.element.toggleAttribute("data-scroll-above", above)
    this.element.toggleAttribute("data-scroll-below", below)
    this.upTarget.disabled = !above
    this.downTarget.disabled = !below
    this.viewportTarget.tabIndex = above || below ? 0 : -1
  }

  scroll(event) {
    const direction = event.params.direction
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.viewportTarget.scrollBy({
      top: direction * this.viewportTarget.clientHeight * 0.75,
      behavior: reducedMotion ? "instant" : "smooth"
    })
  }
}
